import React, { useState, useEffect } from 'react';
import { Spin, message, Table } from 'antd';
import { Bar } from 'react-chartjs-2';
import { organismoscomunales, organizacionesagropecuarias, resguardosindigenas } from '../../../services/perfiles/conponentesServices';
import './tablaG.css';

const ParticipacionCiudadanaComponente = ({ municipioId }) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const constanteInformacion = 'Organismos comunales'; // La constante con la información que deseas agregar
    const [datapecurias, setDatapecurias] = useState([]);
    const [dataresguardos, setDataresguardos] = useState([]);
    const [dataConsejos, setDataConsejos] = useState([]);

    useEffect(() => {
        if (municipioId) {
            fetchData();
            fetchDatapecuaria();
            fetchDataresguardos();
            fetchDataconsejos();
        }
    }, [municipioId]);

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await organismoscomunales(municipioId);
            if (response && response.status === 200) {
                const fetchedData = response.data;
                if (Array.isArray(fetchedData)) {
                    setData(fetchedData);
                } else {
                    throw new Error('Fetched data is not an array');
                }
            } else {
                throw new Error('Invalid response from server');
            }
        } catch (error) {
            message.error('Error loading data');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };
    const fetchDatapecuaria = async () => {
        setLoading(true);
        try {
            const response = await organizacionesagropecuarias(municipioId);
            if (response && response.status === 200) {
                const fetchedData = response.data;
                if (Array.isArray(fetchedData)) {
                    setDatapecurias(fetchedData);
                } else {
                    throw new Error('Fetched data is not an array');
                }
            } else {
                throw new Error('Invalid response from server');
            }
        } catch (error) {
            message.error('Error loading data');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };
    const fetchDataresguardos = async () => {
        setLoading(true);
        try {
            const response = await resguardosindigenas(municipioId);
            if (response && response.status === 200) {
                const fetchedData = response.data;
                if (Array.isArray(fetchedData)) {
                    setDataresguardos(fetchedData);
                } else {
                    throw new Error('Fetched data is not an array');
                }
            } else {
                throw new Error('Invalid response from server');
            }
        } catch (error) {
            message.error('Error loading data');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };
    const fetchDataconsejos = async () => {
        setLoading(true);
        try {
            const response = await resguardosindigenas(municipioId);
            if (response && response.status === 200) {
                const fetchedData = response.data;
                if (Array.isArray(fetchedData)) {
                    setDataConsejos(fetchedData);
                } else {
                    throw new Error('Fetched data is not an array');
                }
            } else {
                throw new Error('Invalid response from server');
            }
        } catch (error) {
            message.error('Error loading data');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };
    const columns = [
        {
            title: 'Organismos Comunales en el Departamento del Cauca',
            dataIndex: 'organismo',
            key: 'organismo',
            width: '20%',
            className: 'filaP',
            render: () => constanteInformacion // Renderiza la constante en esta columna
        },
        {
            title: 'JACs', dataIndex: 'jacs', key: 'jacs', className: 'filaP'
        },
        {
            title: 'Asociaciones JACs', dataIndex: 'asociaciones_jacs', key: 'asociaciones_jacs', className: 'filaP'
        },
        {
            title: 'Asociaciones y Corporaciones', dataIndex: 'asoci_corporaciones', key: 'asoci_corporaciones', className: 'filaP'
        },
    ];

    const chartData = {
        labels: data.map(item => item.municipio), // Usar el campo municipio para etiquetas
        datasets: [
            {
                label: 'JACs',
                data: data.map(item => item.jacs),
                backgroundColor: 'rgba(75, 192, 192, 0.6)',
            },
            {
                label: 'Asociaciones JACs',
                data: data.map(item => item.asociaciones_jacs),
                backgroundColor: 'rgba(153, 102, 255, 0.6)',
            },
            {
                label: 'Asociaciones y Corporaciones',
                data: data.map(item => item.asoci_corporaciones),
                backgroundColor: 'rgba(255, 159, 64, 0.6)',
            },

        ],

    };
    const columnsPecuarias = [
        { title: 'Nombre', dataIndex: 'nombre', key: 'nombre', className: 'filaP' },
        { title: 'Dirección', dataIndex: 'direccion', key: 'direccion', className: 'filaP' },
        { title: 'Municipio', dataIndex: 'municipio', key: 'municipio', className: 'filaP' },
    ];
    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            x: {
                beginAtZero: true,
            },
            y: {
                beginAtZero: true, min: 0, // Valor mínimo visible en el eje Y (puedes ajustarlo según tus necesidades)
            },
        },
    };
    const columnsResguardos = [
        { title: 'Nombre Resguardo', dataIndex: 'nombre_resguardo', key: 'nombre_resguardo', className: 'filaP' },
        { title: 'Comunidad', dataIndex: 'nombre_comunidad', key: 'nombre_comunidad', className: 'filaP' },
        { title: 'Localización', dataIndex: 'localizacion', key: 'localizacion', className: 'filaP' },
        { title: 'Tipo', dataIndex: 'tipo', key: 'tipo', className: 'filaP' },
        { title: 'Pueblo Etnia', dataIndex: 'pueblo_etnia', key: 'pueblo_etnia', className: 'filaP' },
    ]
    const columnsConsejos = [
        { title: 'Nombre Resguardo', dataIndex: 'nombre_resguardo', key: 'nombre_resguardo', className: 'filaP' },
        { title: 'Comunidad', dataIndex: 'nombre_comunidad', key: 'nombre_comunidad', className: 'filaP' },
        { title: 'Localización', dataIndex: 'localizacion', key: 'localizacion', className: 'filaP' },
        { title: 'Tipo', dataIndex: 'tipo', key: 'tipo', className: 'filaP' },
        { title: 'Pueblo Etnia', dataIndex: 'pueblo_etnia', key: 'pueblo_etnia', className: 'filaP' },
    ]
    return (
        <div>
            <h1>PARTICIPACIÓN CIUDADANA</h1>
            <Spin spinning={loading}>
                <div className="section">
                    <Table
                        columns={columns}
                        dataSource={data}
                        rowKey="idorganismos"
                        pagination={false}
                    />
                </div>
            </Spin>
            <div className="chart-container" style={{ height: '450px' }}>
                <Bar data={chartData} options={chartOptions} />
            </div>
            <div className="section">
                <h3>Organizaciones Agropecuarias</h3>
                <Table
                    columns={columnsPecuarias}
                    dataSource={datapecurias}
                    rowKey="idorganizaciones"
                    pagination={{ pageSize: 6 }}
                />
            </div>
            <div className="section">
                <h3>Resguardos Indígenas</h3>
                <Table
                    columns={columnsResguardos}
                    dataSource={dataresguardos}
                    rowKey="id_resguardo"
                    pagination={false}
                />
            </div>
            <div className="section">
                <h3>Consejos Comunitarios</h3>
                <Table
                    columns={columnsConsejos}
                    dataSource={dataConsejos}
                    rowKey="idconsejo"
                    pagination={false}
                />
            </div>
        </div>
    );
};

export default ParticipacionCiudadanaComponente;
